import ApiDrivenModel from "./ApiDrivenModel";
import Item from "./Item";

class ProposalItem extends ApiDrivenModel {
	constructor(properties) {
		super(properties);
		delete this.data; // prevent circular serialization error with JSONing later

		// Setup children
		if (this.item) {
			this.item = new Item(this.item);
		}
	}
	
	/**
	 * @param {ProposalItem|Item|Number} item
	 */
	static Make(item) {
		return item instanceof ProposalItem? item
			: item instanceof Item ? new ProposalItem({ item })
				: Number.isSafeInteger(+item) ? new ProposalItem({ item: new Item({ id: +item }) })
					: undefined;
	}


	static ENDPOINT = "/Proposal_Item";
	static PATHS = {
		id: true,
		created_on: true,
		updated_on: true,
		price: true,
		quantity: true,
		location: true,
		notes: true,
		item: Item.PATHS,
	};
}

export default ProposalItem;
